module.exports = {"id":"189615","name":"Aaron Cresswell","rating":"75","photo":"./data/images/photos/1/189615.png","club":{"name":"West Ham Utd","logo":"./data/images/clubs/WestHamUtd.png"},"positions":["DG","DC","DLG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AaronCresswell0.json
// module id = 43
// module chunks = 0